export default {
    apiUrl :'http://api.cbct.cn/',
    imgUrl:'http://img001.cbct.cn/image/',
    androidDownloadAddress:'http://img001.cbct.cn/package/SFM_M_A_S_cbct.apk',
    iosDownloadAddress:'https://itunes.apple.com/cn/app/id1439524045?mt=8',
    imgUrlAvatar:'http://img001.cbct.cn/avatar/',
    dsUrl:'http://ds.h5.cbct.cn',
    prefixAvatar: 'https://img001.cbct.cn/avatar/'
}
